import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useCustomerService } from "serviceHooks";
import { useNavigate } from "react-router-dom";
import { UrlHelper } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
//#endregion

const InvoicedAmountByCustomerChart: React.FC = () => {
  const customerService = useCustomerService();
  const navigate = useNavigate();

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.CustomerHighestInvoiceTotal}
      doughnutChartColorPalette={ChartEnums.DoughnutChartColorPalette.DEFAULT}
      doughnutChartLegendType={ChartEnums.LegendType.WITH_VALUES}
      filterToAPIHandler={customerService.reportToAPIFilter}
      usePageFilter
      useClickableChart
      onDataPointClick={(index, label) => {
        const clickedLabel = typeof label === "string" ? label : undefined;
        if (!clickedLabel) return;
        customerService.searchInternalCustomers(clickedLabel).then((results) => {
          const exact = results.find((r) => (r.name ?? "").toLowerCase() === clickedLabel.toLowerCase());
          const target = exact ?? results[0];
          if (target?.id) navigate(UrlHelper.formatPath(`/Customer/${target.id}`));
        });
      }}
    />
  );
};

export default InvoicedAmountByCustomerChart;
